$(function() {
  $('#footer .mailing-list form').submit(function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var form = $(this);
    var error = false;

    form.find('.error-msg').hide();
    form.find('.error').removeClass('error');

    form.find('.required').each(function() {
      if ($(this).val() == "") {
        error = true;
        $(this).addClass('error');
      }
    });

    if (error) {
      form.find('.error-msg').show().text('Please enter a valid email address.');
    } else {
      if (!Simplistic.validateEmail(form.find('.email').val())) {
        error = true;
        form.find('.email').addClass('error');
        form.find('.error-msg').show().text('Please enter a valid email address.');
      }
    }

    if (!error) {
      $.ajax({
        data: form.serialize(),url: form.data('ajax-submit'),type: 'POST'
      }).done(function() {
        form.find('.form-wrap').hide();
        form.find('.success-msg').show();
      }).error(function() {
        form.unbind("submit");
        form.submit();
      });
    }
  });
});
